/**
 * Mutations for updating the state via actions.
 * Names should reference from mutation types
 */

import * as types from './mutation-types';

export const mutations = {};
